import "./index.scss";

const SlidingText = ({ heading, subHeading }) => {
  return (
    <div className="sliding-text">
      <div>{heading}</div>
      <div> {subHeading}</div>
    </div>
  );
};
export default SlidingText;
